module.exports = __webpack_public_path__ + "static/img/earrings_02.88d8e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/earrings_02.png
// module id = H8d5
// module chunks = 0